import * as React from "react";
import { styled } from "@mui/material";
import { KahunTitle } from "fe-web-components/styles/typography";
import { MeasurementRange, MeasurementUnits } from "fe-common/graphql";
import { MobileView } from "../../../util/aKaunGeneralUtil";

//region [[ Styles ]]
const AgePresenterView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "baseline",
  marginBottom: "-20px",
  marginTop: "8px",
  [theme.breakpoints.down(MobileView)]: {
    marginBottom: "0px",
    marginTop: "0px",
  },
}));

const AgeMainText = styled(KahunTitle)(
  ({ theme, size }: { theme?: any; size: "small" | "medium" }) => ({
    fontSize: size === "small" ? "22px" : "26px",
    fontWeight: 500,
    marginRight: "5px",
    color: "black",

    [theme.breakpoints.down(MobileView)]: {
      fontSize: "16px",
      color: "white",
      fontWeight: 700,
    },
  }),
);

const AgeSubText = styled(KahunTitle)(({ theme }) => ({
  fontSize: "18px",
  color: "#494949",
  fontWeight: 500,

  [theme.breakpoints.down(MobileView)]: {
    color: "white",
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]
export interface AgePresenterProps {
  className?: string;
  age?: MeasurementRange;
  textSize?: "small" | "medium";
  onClick?: () => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AgePresenter = ({ ...props }: AgePresenterProps) => {
  const age = props.age ? `${props.age.low}` : "";

  const ageText =
    props.age?.units === MeasurementUnits.Years
      ? " Years"
      : props.age?.units === MeasurementUnits.Weeks
      ? " Weeks"
      : "Age";

  return (
    <AgePresenterView className={props.className} onClick={props.onClick}>
      {props.age && (
        <AgeMainText size={props.textSize} className="age-presenter-number">
          {age}
        </AgeMainText>
      )}
      <AgeSubText className="age-presenter-units">{ageText}</AgeSubText>
    </AgePresenterView>
  );
};
